export default "__VITE_ASSET__Bqi_Odzd__"